import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CarsWidgetFormType } from '../models/cars-widget-form.interfaces';
import { CarsWidget } from '../models/cars-widget.interface';
import { CarsFormValidationService } from './cars-form-validation.service';

@Injectable({
  providedIn: 'root'
})
export class CarsFormLifecycleService {
  constructor(private validationService: CarsFormValidationService) {}

  setupFormValueChanges(
    form: FormGroup<CarsWidgetFormType>,
    content: CarsWidget,
    getIsSubmitted: () => boolean,
    destroy$: Subject<void>,
    onError: (
      errors: ReturnType<typeof this.validationService.validateForm>
    ) => void
  ): void {
    form.valueChanges.pipe(takeUntil(destroy$)).subscribe(() => {
      if (getIsSubmitted()) {
        const errors = this.validationService.validateForm(form, content);
        onError(errors);
      }
    });
  }

  markFormAsTouched(form: FormGroup<CarsWidgetFormType>): void {
    Object.keys(form.controls).forEach((key) => {
      form.get(key)?.markAsTouched();
    });
  }
}
